import { useAppDispatch, useAppSelector } from '../store/hooks';
import { setActivePage } from '../store/navigationSlice';
import { ActiveWebsitePage } from '../types/ActiveWebsitePageEnum';

export const useNavigation = () => {
  const dispatch = useAppDispatch();
  const activePage = useAppSelector((state) => state.navigation.activePage);

  const navigateToPage = (page: ActiveWebsitePage) => {
    dispatch(setActivePage(page));
  };

  return {
    activePage,
    navigateToPage,
  };
};
